import { submitEventHandler, fetchApiData, loadPage, PICAction } from '../Internals';
export async function fetchContextData(iFetchPath, iFetchOpt) {
    let tmp = {
        postBody: {
            mode: 'getContext',
            data: {
                progPath: iFetchPath,
                parms: iFetchOpt
            }
        }
    };
    return fetchApiData('incl/contextapi', tmp).then((data) => {
        return pca(data);
    });
}
function pca(iContext) {
    let resContextArr = [];
    if (iContext)
        iContext.forEach(cLine => {
            if (cLine.eventFncKey && cLine.eventTxt) {
                if (cLine.eventFncKey === 'loadPage') {
                    cLine.eventFnc = () => { loadPage(...cLine.eventTxt.split(',')); };
                }
                else if (cLine.eventFncKey === 'doSubmit') {
                    cLine.eventFnc = (e) => { submitEventHandler(e, cLine.eventTxt); };
                }
            }
            resContextArr.push(cLine);
        });
    if (!(resContextArr.length > 0))
        resContextArr = iContext;
    return resContextArr;
}
export function parseContextArr(iContext, iOptions) {
    let resContextArr = [];
    if (iContext) {
        iContext.forEach(cLine => {
            if (cLine.eventFncKey) {
                if (cLine.eventFncKey === 'loadPage') {
                    let lpAction = new PICAction();
                    lpAction.type_ = 'loadPage';
                    let evtArr = cLine.eventTxt.split(',');
                    lpAction.progpath_ = evtArr && evtArr.length > 0 ? evtArr[0] : cLine.eventTxt;
                    lpAction.parms_ = evtArr && evtArr.length > 1 ? evtArr[1] : '';
                    cLine.eventFnc = lpAction;
                }
                else if (cLine.eventFncKey === 'doSubmit') {
                    cLine.eventFnc = (e) => { submitEventHandler(e, cLine.eventTxt); };
                }
                else if (cLine.eventFncKey === 'subMenu' && cLine.subContext) {
                    cLine.subContext = parseContextArr(cLine.subContext, iOptions);
                }
                else if (cLine.eventFncKey === 'action' && cLine.eventTxt) {
                    let action = new PICAction();
                    action.type_ = 'command';
                    let iType = JSON.parse(cLine.eventTxt);
                    cLine.eventTxt = '';
                    action.event_ = iType.type;
                    action.parms_ = iType.parms;
                    cLine.eventFnc = action;
                }
            }
            resContextArr.push(cLine);
        });
    }
    if (!(resContextArr.length > 0))
        resContextArr = iContext;
    return resContextArr;
}
//# sourceMappingURL=PICParsers.js.map